<div class="checkbox-container" [class.checked]="checked" [class.disabled]="disabled">
  @if (checked) {
    <cs-icon name="checkmark" class="checkmark-icon"></cs-icon>
  }
</div>
<!-- role and an explicit aria-checked in both states, so a screen reader announces a checkbox
     that is "checked" or "not checked" rather than a plain button -->
<button (click)="handleClick($event)" cs-capture-cover [disabled]="disabled" role="checkbox"
[attr.aria-label]="ariaLabel || null"
[attr.aria-checked]="checked ? 'true' : 'false'"></button>